import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

// Three states: undefined = checking session, null = signed out, { email } = signed in.
const AuthContext = createContext({
  user: undefined,
  signIn: async () => {},
  signOut: async () => {},
  refresh: async () => {},
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser({ email: r.data.email });
    } catch {
      setUser(null);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const signIn = useCallback(async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    // Clear any legacy localStorage token — cookie is now the source of truth.
    localStorage.removeItem("receipts_token");
    localStorage.removeItem("receipts_admin_email");
    setUser({ email: r.data.email });
    return r.data;
  }, []);

  const signOut = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      console.error("Logout request failed", err);
    }
    localStorage.removeItem("receipts_token");
    localStorage.removeItem("receipts_admin_email");
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, signIn, signOut, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
